module.exports = __webpack_public_path__ + "fonts/pws-icons.1d22ead0.ttf";